module.exports = __webpack_public_path__ + "img/aniLogo.6956cf69.png";